export default "__VITE_ASSET__CivxF3mb__"